(function() {
  var threshold = 6500;

  function updateBar(total) {
    var remaining = threshold - total;
    var percent = Math.min((total / threshold) * 100, 100);
    var fill = document.getElementById('free-shipping-fill-drawer');
    var message = document.getElementById('free-shipping-message-drawer');
    if (fill) fill.style.width = percent + '%';
    if (message) {
      if (remaining > 0) {
        var euros = Math.floor(remaining / 100);
        var cents = remaining % 100;
        var formatted = '€' + euros + ',' + (cents < 10 ? '0' : '') + cents;
        message.textContent = '🚚 Nog ' + formatted + ' voor gratis verzending binnen Nederland bij bestellingen tot en met 10 kg';
      } else {
        message.textContent = '✅ Gratis verzending binnen Nederland vanaf €65 bij bestellingen tot en met 10 kg. Boven 10 kg worden verzendkosten berekend bij het afrekenen.';
      }
    }
  }

  function fetchAndUpdate() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { updateBar(cart.total_price); })
      .catch(function() {});
  }

  // Bij laden
  fetchAndUpdate();

  // Dawn thema events
  document.addEventListener('cart:updated', fetchAndUpdate);
  document.addEventListener('cart:refresh', fetchAndUpdate);

  // Onderschep fetch
  var origFetch = window.fetch;
  window.fetch = function() {
    var url = arguments[0];
    var result = origFetch.apply(this, arguments);
    if (typeof url === 'string' && (
      url.includes('/cart/change') ||
      url.includes('/cart/add') ||
      url.includes('/cart/update')
    )) {
      result.then(function(r) {
        return r.clone().json();
      }).then(function(cart) {
        if (cart && cart.total_price !== undefined) updateBar(cart.total_price);
      }).catch(function() {});
    }
    return result;
  };

  // Onderschep XMLHttpRequest als fallback
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function() {
    var xhr = this;
    if (xhr._url && (
      xhr._url.includes('/cart/change') ||
      xhr._url.includes('/cart/add') ||
      xhr._url.includes('/cart/update')
    )) {
      xhr.addEventListener('load', function() {
        setTimeout(fetchAndUpdate, 200);
      });
    }
    return origSend.apply(this, arguments);
  };

  // Polling als extra fallback (elke 1.5 seconde)
  setInterval(fetchAndUpdate, 1500);
})();